import { formatISO } from 'date-fns'
import { computed, MaybeRefOrGetter, toValue } from 'vue'

export type QueryLike =
  | Record<string, string | number | boolean | Date | null | undefined>
  | URLSearchParams

export function toQuery(query: QueryLike): URLSearchParams {
  if (query instanceof URLSearchParams) return query
  const _query: Record<string, string> = {}
  for (const [key, value] of Object.entries(query)) {
    if (value === null || value === undefined) continue
    _query[key] = value instanceof Date ? formatISO(value) : value.toString()
  }
  return new URLSearchParams(_query)
}

export function useQuery(query: MaybeRefOrGetter<QueryLike>) {
  return computed(() => toQuery(toValue(query)))
}
